let storage: {
    [key: string]: any;
};

try {
    storage = window.localStorage || {};
} catch (_) {
    storage = {};
}

/** helper for getting local storage JSON data as object and viceversa?  */
export const LocalStorage = new Proxy(storage, {
    get: (it, prop: string) => {
        return prop in it ? JSON.parse(it[prop]) : undefined;
    },
    set: (it, prop: string, value) => {
        it[prop] = JSON.stringify(value);

        return true;
    }
});
